import { Box, Grid, Paper, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context";

import { useTheme } from "@mui/material/styles";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const HTPatientNav = () => {
  const theme = useTheme();
  const auth = useAuth();
  const { t } = useTranslation();
  const [value, setValue] = useState("/htPatient");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "htPatient",
      "/htPatient/view-procedure",
      "/htPatient/new-patient",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/htPatient");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/htPatient" ? theme.palette.primary.main : "white",
                color: value === "/htPatient" ? "white" : "black",
              }}
              label={t("reception.dashboard", "Dashboard")}
              value="/htPatient"
              component={NavLink}
              to="/htPatient"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/htPatient/new-patient"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/htPatient/new-patient" ? "white" : "black",
              }}
              label={t("reception.newPatient")}
              value="/htPatient/new-patient"
              component={NavLink}
              to="/htPatient/new-patient"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/htPatient/add-ht-procedure"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/htPatient/add-ht-procedure" ? "white" : "black",
              }}
              label={t("call_center.addProcedure")}
              value="/htPatient/add-ht-procedure"
              component={NavLink}
              to="/htPatient/add-ht-procedure"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/htPatient/view-procedure"
                    ? theme.palette.primary.main
                    : "transparent",
                color:
                  value === "/htPatient/view-procedure" ? "white" : "black",
              }}
              label={t("call_center.viewProcedure")}
              value="/htPatient/view-procedure"
              component={NavLink}
              to="/htPatient/view-procedure"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default HTPatientNav;
